export default {
  state: {
    optin: {
      enabled: false,
      shared: [],
      showModal: false
    }
  },
  mutations: {
    setOptinData (state, data) {
      for (let field in data) {
        state.optin[field] = data[field]
      }
    },
    addSharedService (state, value) {
      state.optin.shared.push(value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/optin.js